<div class="file-card">
    <div class="icon-container" data-cy="icon-container">
        <sirius-icon [name]="siriusIconName"></sirius-icon>
    </div>
    <div class="file-text-container">
        <h3 class="file-title sir-text-style-title-xs-default" data-cy="file-title">{{ fileTitle }}</h3>
        <p class="file-description sir-text-style-paragraph-m-default" data-cy="file-description">{{ fileDescription }}</p>
        <a
            class="download-button"
            data-cy="download-button"
            siriusButton
            [buttonText]="buttonText"
            [buttonType]="'linkstyle'"
            [siriusLink]="link">
        </a>
    </div>
</div>
